import _get from "lodash.get";

import rolesConstants from "@/components/acl/roles";

import EventStatus from "@components/Dashboard/EventStatus";
import CertificateLayout from "@components/Dashboard/Layout/CertificateLayout.vue";
import DashboardLayout from "@components/Dashboard/Layout/DashboardLayout.vue";
import Home from "@components/Dashboard/Layout/Home.vue";
import PrintLayout from "@components/Dashboard/Layout/PrintLayout.vue";
import TrainingStatus from "@components/Dashboard/TrainingStatus";
import TrainingExit from "@components/Dashboard/Views/Pages/TrainingExit";
import AccessForbidden from "@components/GeneralViews/AccessForbiddenPage.vue";
import NotFound from "@components/GeneralViews/NotFoundPage.vue";

import ForgotPassword from "@components/Dashboard/Views/Pages/ForgotPassword.vue";
import Lock from "@components/Dashboard/Views/Pages/Lock.vue";
import Login from "@components/Dashboard/Views/Pages/Login.vue";
// import Maintenance from "@/components/Dashboard/Views/Pages/Maintenance";


import Logout from "@components/Dashboard/Views/Pages/Logout.vue";
import ResetPassword from "@components/Dashboard/Views/Pages/ResetPassword.vue";
import User from "@components/Dashboard/Views/Pages/UserProfile.vue";

import CompanyGroups from "@components/Dashboard/Views/Pages/Company/Groups";
import CreateGroup from "@components/Dashboard/Views/Pages/Company/Groups/CreateGroup";
import GroupDetail from "@components/Dashboard/Views/Pages/Company/Groups/GroupDetail";
import GroupEdit from "@components/Dashboard/Views/Pages/Company/Groups/GroupEdit";

import CompanyProfile from "@components/Dashboard/Views/Pages/Company/Profile";
import EditCompanyProfile from "@components/Dashboard/Views/Pages/Company/Profile/EditCompanyProfile";

import CompanyUserList from "@components/Dashboard/Views/Pages/Company/Users/List";
import CompanyUserHistorical from "@components/Dashboard/Views/Pages/Company/Users/Historical";
import CompanyUserEdit from "@components/Dashboard/Views/Pages/Company/Users/Edit";
import CompanyUserCreate from "@components/Dashboard/Views/Pages/Company/Users/Create";
import CompanyUserShow from "@components/Dashboard/Views/Pages/Company/Users/Show";
import CompanyUserCertificatePrint from "@components/Dashboard/Views/Pages/Company/Users/Training/Record/Certificate";
import CompanyUserRecordPrint from "@components/Dashboard/Views/Pages/Company/Users/Training/Record/Print";

import TrainingProgram from "@components/Dashboard/Views/Pages/Training/Program";
import TrainingCertificatePrint from "@components/Dashboard/Views/Pages/Training/Record/Certificate";
import TrainingRecordPrint from "@components/Dashboard/Views/Pages/Training/Record/Print";
import TrainingRecord from "@components/Dashboard/Views/Pages/Training/Record/Record";
import TrainingSchedule from "@components/Dashboard/Views/Pages/Training/Schedule";
import Training from "@components/Dashboard/Views/Pages/Training/Training";

import Settings from "@components/Dashboard/Views/Pages/Settings";

import EventCreate from "@/components/Users/My/Events/EventCreate";
import Events from "@/components/Users/My/Events/Events";
import EventShow from "@/components/Users/My/Events/EventShow";
import EventUpdate from "@/components/Users/My/Events/EventUpdate";

const loginPage = {
  path: "/login",
  name: "system@login",
  component: Login,
  meta: {
    title: "Login"
  }
};

// const cutOver = {
//   path: "/cutover",
//   name: "system@cutover",
//   component: Login,
//   meta: {
//     title: "Login"
//   }
// };

const logoutPage = {
  path: "/logout",
  name: "system@logout",
  component: Logout,
  meta: {
    title: "Logout",
    menu: "user"
  }
};

const lockPage = {
  path: "/lock",
  name: "system@lock",
  component: Lock,
  meta: {
    title: "Lock",
    menu: "user"
  }
};

const forbiddenPage = {
  path: "/forbidden",
  name: "system@forbidden",
  component: AccessForbidden,
  meta: {
    title: "Access Forbidden"
  }
};

const notFoundPage = {
  path: "/404",
  name: "system@not-found",
  component: NotFound,
  meta: {
    title: "Page Not Found"
  }
};

const home = {
  path: "/",
  name: "home",
  component: Home,
  meta: {
    title: "Home",
  }
};

const dashboard = {
  path: "/dashboard",
  name: "dashboard",
  component: DashboardLayout,
  redirect: { name: "dashboard@training-status" },
  children: [
    {
      path: "training-status",
      name: "dashboard@training-status",
      component: TrainingStatus,
      meta: {
        title: "Training Status",
        icon: "far fa-user-chart"
      }
    },
    {
      path: "event-status",
      name: "dashboard@event-status",
      component: EventStatus,
      meta: {
        title: "Event / Document Status",
        icon: "far fa-user-chart"
      }
    },
    {
      path: "/profile",
      name: "users@profile",
      component: User,
      meta: {
        title: "My profile",
        icon: "far fa-user-chart",
        menu: "user"
      }
    },
    forbiddenPage,
    notFoundPage
  ],
  meta: {
    title: "Dashboard",
    icon: "far fa-analytics",
    permissions: ["companies_dashboard"],
    menu: "sidebar",
    collapsed: false
  }
};

const companyUsers = [
  {
    path: "/company/users/active",
    name: "companies_users@active",
    component: CompanyUserList,
    meta: {
      title: "People",
      permissions: ["companies_users_index"],
      icon: "far fa-users-class",
      menu: "sidebar",
      collapsed: false
    }
  },
  {
    path: "/company/users/historical",
    name: "companies_users@historical",
    component: CompanyUserHistorical,
    meta: {
      title: "Historical",
      permissions: ["companies_users_index"],
      icon: "far fa-rectangle-history-circle-user",
      menu: "sidebar",
      collapsed: false
    }
  },
  {
    path: "/company/users/create",
    name: "companies_users@create",
    component: CompanyUserCreate,
    meta: {
      title: "Create Person",
      permissions: ["companies_users_store"]
    }
  },
  {
    path: "/company/users/:id",
    name: "companies_users@show",
    component: CompanyUserShow,
    meta: {
      title: "Person Detail",
      permissions: ["companies_users_show"]
    }
  },
  {
    path: "/company/users/:id/edit",
    name: "companies_users@edit",
    component: CompanyUserEdit,
    meta: {
      title: "Edit Person",
      permissions: ["companies_users_update"]
    }
  }
];

const companyGroup = [
  {
    path: "/company/groups",
    name: "companies_groups@index",
    component: CompanyGroups,
    meta: {
      title: "Groups",
      permissions: ["companies_groups_index"],
      icon: "far fa-users",
      menu: "sidebar",
      collapsed: false
    }
  },
  {
    path: "/company/groups/create",
    name: "companies_groups@create",
    component: CreateGroup,
    meta: {
      title: "Create Group",
      permissions: ["companies_groups_create"]
    }
  },
  {
    path: "/company/groups/:id",
    name: "companies_groups@show",
    component: GroupDetail,
    meta: {
      title: "Group Detail",
      permissions: ["companies_groups_show"]
    }
  },
  {
    path: "/company/groups/:id/edit",
    name: "companies_groups@edit",
    component: GroupEdit,
    meta: {
      title: "Edit Group",
      permissions: ["companies_groups_update"]
    }
  }
];

const companyPage = {
  path: "/company",
  name: "companies@index",
  redirect: { name: "companies@show" },
  component: DashboardLayout,
  children: [
    {
      path: "/company/profile",
      name: "companies@show",
      component: CompanyProfile,
      meta: {
        title: "Profile",
        permissions: ["companies_show"],
        icon: "far fa-address-card"
      }
    },
    {
      path: "/company/profile/edit",
      name: "companies@edit",
      component: EditCompanyProfile,
      meta: {
        title: "Edit Profile",
        permissions: ["companies_update"]
      }
    },
    ...companyGroup,
    ...companyUsers
  ],
  meta: {
    icon: "far fa-building",
    title: "Company",
    permissions: [
      "companies_show",
      "companies_groups_index",
      "companies_users_index"
    ],
    menu: "sidebar",
    collapsed: false
  }
};

const myEvents = [
  {
    path: "/my/events",
    name: "my_events@index",
    component: Events,
    meta: {
      title: "Events",
    }
  },
  {
    path: "/my/events/create",
    name: "my_events@create",
    component: EventCreate,
    meta: {
      title: "Events",
    }
  },
  {
    path: "/my/events/:id",
    name: "my_events@show",
    component: EventShow,
    meta: {
      title: "Events",
    }
  },
  {
    path: "/my/events/:id/update",
    name: "my_events@update",
    component: EventUpdate,
    meta: {
      title: "Events",
    }
  },
];

const trainingPage = {
  path: "/my",
  name: "my",
  redirect: { name: "my@training" },
  component: DashboardLayout,
  children: [
    {
      path: "/my/training",
      name: "my@training",
      component: Training,
      meta: {
        title: "Training"
      }
    },
    {
      path: "/my/program",
      name: "my@program",
      component: TrainingProgram,
      meta: {
        title: "Training Program"
      }
    },
    {
      path: "/my/schedule",
      name: "my@schedule",
      component: TrainingSchedule,
      meta: {
        title: "Training Schedule"
      }
    },
    {
      path: "/my/records",
      name: "my@records",
      component: TrainingRecord,
      meta: {
        title: "Training Record"
      }
    },
  ].concat(myEvents)
};

const settingsRoute = {
  path: "/settings",
  component: DashboardLayout,
  meta: {},
  children: [
    {
      path: "/settings",
      name: "system@settings",
      component: Settings,
      meta: {
        title: "Settings",
        roles: [rolesConstants.ROLE_ADMIN],
        icon: "far fa-building"
      }
    }
  ]
};

const print = {
  path: "/print",
  name: "system@record-print",
  component: PrintLayout,
  children: [
    {
      path: "/my/record/print",
      name: "my@records-print",
      component: TrainingRecordPrint,
      meta: {
        title: "Training Record Print"
      }
    },
    {
      path: "/company/users/:id/record/print",
      name: "companies_users@records-print",
      component: CompanyUserRecordPrint,
      meta: {
        title: "Training Record Print"
      }
    }
  ]
};

const certificate = {
  path: "/print",
  name: "system@certificate-print",
  component: CertificateLayout,
  children: [
    {
      path: "/training/record/certificate/:hash/print",
      name: "my@certificate-print",
      component: TrainingCertificatePrint,
      meta: {
        title: "Training Certificate Print"
      }
    },
    {
      path: "/company/users/:id/record/certificate/:hash/print",
      name: "companies_users@certificate_print",
      component: CompanyUserCertificatePrint,
      meta: {
        title: "Training Certificate Print"
      }
    }
  ]
};

const trainingExit = {
  path: "/training_exit",
  name: "system@training_exit",
  component: TrainingExit,
};

const resetPage = {
  path: "/reset-password",
  name: "system@resetPassword",
  component: ResetPassword,
  meta: {
    title: "Reset Password"
  }
};

const forgotPassword = {
  path: "/password/reset/:id",
  name: "system@resetPassword",
  component: ForgotPassword,
  meta: {
    title: "Reset Password"
  }
};

const routes = [
  // cutOver,
  home,
  companyPage,
  trainingPage,
  loginPage,
  resetPage,
  forgotPassword,
  lockPage,
  dashboard,
  logoutPage,
  settingsRoute,
  print,
  certificate,
  trainingExit,
  { path: "*", component: NotFound }
];

const handleRouteChildren = list => {
  const subMenuList = [];
  list.forEach(route => {
    const item = {
      name: route.name,
      title: route.meta.title,
      icon: route.meta.icon,
      collapsed: route.meta.collapsed,
      permissions: route.meta.permissions,
      roles: route.meta.roles
    };
    menuList.push(item);
  });

  return subMenuList;
};

const menuList = [];

routes.forEach(route => {
  if (!_get(route, "meta.menu")) {
    return;
  }

  if (route.meta.menu === "user") {
    const item = {
      name: route.name,
      title: route.meta.title,
      icon: route.meta.icon,
      collapsed: route.meta.collapsed,
      permissions: route.meta.permissions,
      roles: route.meta.roles
    };

    if (_get(route, "children")) {
      const children = handleRouteChildren(route.children);
      item.children = children;
    }

    menuList.push(item);
  }

  if (route.meta.menu === "sidebar") {
    const item = {
      name: route.name,
      title: route.meta.title,
      icon: route.meta.icon,
      collapsed: route.meta.collapsed,
      permissions: route.meta.permissions,
      roles: route.meta.roles
    };

    if (_get(route, "children")) {
      const children = handleRouteChildren(route.children);
      item.children = children;
    }

    menuList.push(item);
  }
});

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('@components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default { routes, menuList };
